




























































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import articleDetailType1 from "@/components/articleDetailType1.vue";
import articleDetailType2 from "@/components/articleDetailType2.vue";
import articleDetailType3 from "@/components/articleDetailType3.vue";
import {
  getCmsCompanyDetail,
  getCmsArticleDetail,
  getCmsColumnDetail,
  headerData,
} from "@/axios";
@Component({
  name: "articlePage",
  components: {
    "v-articleDetailType1": articleDetailType1,
    "v-articleDetailType2": articleDetailType2,
    "v-articleDetailType3": articleDetailType3,
  },
})
export default class extends Vue {
  private showType: any = "";
  private navIndex: any = "";
  private navIndexOld: any = "";
  private notLandmark: any = true;
  private searchValue: any = "";

  // 导航数据
  private navData: any = [];

  private landmarkId: any = "";
  private landmarkTitle: any = "";
  private landmarkName: any = "";

  private companyDetail: any = null;
  private articleDetail: any = null;
  private articleColumn: any = null;

  created() {
    let contentType = (this as any).$route.query.type;
    this.landmarkId = this.$route.query.landmarkId;

    headerData({
      landmark_id: this.landmarkId,
    }).then((res: any) => {
      let data = res.data.data;
      this.navData = data.headerData;
      this.landmarkTitle = data.title;
      this.landmarkName = data.headerData[0].column;
    });

    switch (contentType) {
      case "0":
        this.showType = 0;
        getCmsColumnDetail({
          id: (this as any).$route.query.id,
          landmark_id: this.landmarkId,
        }).then((res: any) => {
          this.articleColumn = res.data.data;
        });
        break;
      case "1":
        this.showType = 1;
        getCmsArticleDetail({
          id: (this as any).$route.query.id,
        }).then((res: any) => {
          this.articleDetail = res.data.data;
        });
        break;
      case "2":
        this.showType = 2;
        if ((this as any).$route.query.id) {
          getCmsCompanyDetail({
            id: (this as any).$route.query.id,
          }).then((res: any) => {
            this.companyDetail = res.data.data;
          });
        }
        break;
      default:
        console.log("无匹配");
    }
  }

  private getImgUrl(id: any) {
    return require("@/assets/images/indexNavIcon" + id + ".png");
  }

  // 改变nav索引
  private changeNavIndex(id: any) {
    // this.navIndex = id;
    // if (id != 1) {
    //   this.navIndexOld = id;
    // }
  }

  private closeLandmarkDialog() {
    this.landmarkDialogShow = false;
  }

  private landmarkDialogShow: any = false;
  private landmarkUrl: any = "";

  private showLandmark() {
    // var url =
    //   "https://cms.fjyoulunsw.com:9100/sign_vr/#/?goodsId=" + this.landmarkId + "";
    var url =
      document.location.protocol +
      "//cms.fjyoulunsw.com/sign_vr_v2/#/aPicture?id=1&landmarkId=" +
      this.landmarkId +
      "&landmarkName=" +
      this.landmarkName;
    this.landmarkUrl = url;
    this.landmarkDialogShow = true;
  }

  private toLandmarkIndex(index: any) {
    if (index == 1) {
      if (!this.landmarkId) {
        this.landmarkId = "";
      }
      this.showLandmark();
    } else {
      if (!this.landmarkId) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.$router.push({
          path: "/landmarkIndex",
          query: { landmarkId: this.landmarkId },
        });
      }
    }
  }

  private toIndex() {
    this.$router.push({
      path: "/",
    });
  }

  private toOther() {
    window.location.href = "https://cms.fjyoulunsw.com:9100/web_new/#/login";
  }

  private toSearch(value: any) {
    if (value.length != 0) {
      this.$router.push({
        path: "/search",
        query: {
          searchValue: value,
          landmarkId: (this as any).$route.query.landmarkId,
        },
      });
    }
  }

  mounted() {}

  updated() {}
}
